module.exports = __webpack_public_path__ + "h5/img/pk_wangqi.d2b07802.jpg";